var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointOfInterestBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#ffffff",
    stroke: "#8e24aa",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14) scale(1.5)",
    fill: "none",
    stroke: "#8e24aa",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10h20",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10v3M19 10v3",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 19q5-6 10-6t10 6",
    strokeWidth: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointOfInterestBridge);
export default __webpack_public_path__ + "static/media/PointOfInterestBridge.02744cc90ab9cf0ba6faa1a0f3955bd8.svg";
export { ForwardRef as ReactComponent };